export const PROFILE_LINK = '/profile';
export const MOTORCYCLES_LINK = '/my-garage';
export const MAP_LINK = '/my-maps';
export const USER_MAPS_LIST = '/user-maps';
export const USER_SHARED_MAPS = '/shared';
export const USERS_LIST = '/users';
export const DASHBOARD = '/';
export const SETTINGS_PAGE = '/settings';
export const LOGOUT_PAGE = '/logout';
